import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

//Modules
import auth from './auth.js';
import main from './main.js';

const store = new Vuex.Store({
  plugins: [
    createPersistedState({})
  ],
  getters: {
    error: (state) => {
      return state.error
    },
    standby: (state) => {
      return state.standby
    },
    success: (state) => {
      return state.success
    },
    successTrigger: (state) => {
      return state.successTrigger
    }
  },

  actions: {},
  mutations: {
    onStandby(state, value) {
      state.standby = value
    },
    onError(state, value) {
      state.error = value;
    },
    onSuccess(state, value) {
      state.success = value;
      state.successTrigger = Date.now();
    }
  },

  modules: {
    auth,
    main
  }
})

export default store;